import { Component, OnInit } from '@angular/core';
import { ColDef, GridOptions } from 'ag-grid-community';
import { HttpClient } from '@angular/common/http';
import { Router,ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-members-panel',
  templateUrl: './members-panel.component.html',
  styleUrls: ['./members-panel.component.css']
})
export class MembersPanelComponent implements OnInit{
  currentPage:any;
  totalPages:any;
  loc: any;
  events: any[]=[];
  pager: any;
  members: any[]=[];
  weatherWorking: boolean=false;
  error: string='';
  LocationID:any='';


  constructor(private http: HttpClient,private router: Router,private route: ActivatedRoute, private AuthService: AuthService, private userService: UserService) {}

  goToPage(pageNumber: number):void {
    // Ensure the page number is within valid bounds
    // Ensure the page number is within valid bounds
    this.currentPage = Math.min(Math.max(1, pageNumber), this.totalPages);

    this.userService.getMembersByPage(this.LocationID, this.currentPage).subscribe(
      (data) => {
        if (data != null) {
          this.memberData = data;
        }
      },
      (error) => {
        console.error('Error fetching member data:', error);
      }
    );
  }


  memberData: any[]=[]; // Variable to hold the member data for the Ag Grid table

 

  ngOnInit(): void {
    this.route.paramMap.forEach((params) => {
      this.LocationID = params.get('id')!;
    });

    this.goToPage(1);
  }

  // Method to fetch member data from the API
  fetchMemberData(): void {
    this.userService.getAllMembers(this.LocationID).subscribe(
      (data) => {
        if (data.items != null) {
          this.memberData = data.items;
        }
      },
      (error) => {
        console.error('Error fetching member data:', error);
      }
    );
  } 

  capitalizeFirstLetter(str: string | null | undefined): string {
    if (!str) {
      return '';
    }
    const capitalizedStr = str.charAt(0).toUpperCase() + str.slice(1);
    return capitalizedStr.replace(/_/g, ' ');
  }

  roleMappings: { [key: string]: { display: string; tooltip: string } } = {
    'owner': { display: 'Owner', tooltip: 'Chief Member' },
    'activator': { display: 'Activator', tooltip: 'Deputy Member' },
    'viewer': { display: 'Viewer', tooltip: 'Crew Member' }
  };
  
  getDisplayRole(role: string): string {
    return this.roleMappings[role]?.display || this.capitalizeFirstLetter(role);
  }
  
  getRoleTooltip(role: string): string {
    return this.roleMappings[role]?.tooltip || this.capitalizeFirstLetter(role);
  }

  navigateToUserInfo(userID: string) {
    this.router.navigate(['/user-info',userID]);
  }
}
